import gql from 'graphql-tag'

export default gql`mutation go($user_id: Int!, $permissions: [PermissionInput]!){
  upsertUserPermissions(user_id: $user_id, permissions: $permissions){
    user_id
    first_name
    last_name
    email
    user_role_id
    standard_hours_work_per_week
    active
    line_manager_user_id
    office_id
    login_id
    login{
      login_id
      username
    }
    date_created
    standard_hours_leave_allowance
    included_in_unallocated_days_report
    mobile
    phone_number
    timesheet_entry_required
    display_in_scheduler
    permissions{
      permission_id
      name
      access
    }
    undertime_weeks{
      week_commencing
      total_minutes_worked
    }
  }
}`